import { Box, BoxProps, Heading, Stack, Text } from "@chakra-ui/react";

interface CardProps extends BoxProps {
  label: string;
  value: string | number;
  headerSize?: string;
  subtext?: string;
  icon?: React.ReactNode;
}

export const Card = ({
  label,
  value,
  headerSize,
  subtext,
  icon,
  ...boxProps
}: CardProps) => (
  <Box
    px={{ base: "4", md: "4" }}
    py={{ base: "5", md: "4" }}
    bg="bg-surface"
    borderRadius="lg"
    borderWidth={"1px"}
    borderColor="gray.200"
    {...boxProps}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack>
        <Text fontSize="sm" color="muted">
          {label}
        </Text>
        <Heading size={headerSize}>{value}</Heading>
        {subtext ? <Text fontSize={"xs"}>{subtext}</Text> : null}
      </Stack>
      {icon ? <Box>{icon}</Box> : null}
    </Stack>
  </Box>
);
